// Exact acknowledged market-history notices invalidate reads; they never acquire.
import { CalculatorSocket } from './mackCalculatorNotifications';
import { RETAINED_PRICE_AUTHORITY, RETAINED_PRICE_SOURCES, priceHistoryHash } from './mackRetainedPriceHistory';

const FIELD = 'mack.shared.market.tradingview.cboe_vix.1m';
export function isMackFlowChange(raw: unknown): raw is { change_id: string } {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return false;
  const p = raw as Record<string, unknown>;
  const keys = ['schema', 'domain', 'agent', 'panel', 'read_route', 'producer_id',
    'field_ids', 'kind', 'material_hash', 'change_id'];
  const archiveKeys = [...keys, 'scope', 'version_id', 'authority_sha256', 'history_ack_sha256', 'acknowledged_at'];
  if (Object.keys(p).length === archiveKeys.length && archiveKeys.every(k => Object.prototype.hasOwnProperty.call(p, k))) {
    const field = Array.isArray(p.field_ids) && p.field_ids.length === 1 ? p.field_ids[0] : null;
    const source = typeof field === 'string' && Object.prototype.hasOwnProperty.call(RETAINED_PRICE_SOURCES, field) ? RETAINED_PRICE_SOURCES[field] : null;
    return !!source && p.schema === 'mack_flow_change_v1' && p.domain === 'TRADING' && p.agent === 'MACK' &&
      p.panel === 'Flow & Feasibility' && p.read_route === '/api/mack/flow' && p.producer_id === source.producer &&
      p.kind === 'RETAINED_MARKET_HISTORY_ACKNOWLEDGED' && p.scope === 'PRODUCTION' &&
      p.authority_sha256 === RETAINED_PRICE_AUTHORITY && priceHistoryHash(p.version_id) &&
      priceHistoryHash(p.history_ack_sha256) && priceHistoryHash(p.material_hash) &&
      p.change_id === `mack_price_history_change_${p.material_hash}` &&
      typeof p.acknowledged_at === 'string' && /^\d{4}-\d{2}-\d{2}T.*(?:Z|\+00:00)$/.test(p.acknowledged_at) &&
      Number.isFinite(Date.parse(p.acknowledged_at));
  }
  return Object.keys(p).length === keys.length && keys.every(k => Object.prototype.hasOwnProperty.call(p, k)) &&
    p.schema === 'mack_flow_change_v1' && p.domain === 'TRADING' && p.agent === 'MACK' &&
    p.panel === 'Flow & Feasibility' && p.read_route === '/api/mack/flow' &&
    p.producer_id === 'mack_flow_vix_retained_history_v1' && p.kind === 'RETAINED_MARKET_HISTORY_ACKNOWLEDGED' &&
    Array.isArray(p.field_ids) && p.field_ids.length === 1 && p.field_ids[0] === FIELD &&
    typeof p.material_hash === 'string' && /^[a-f0-9]{64}$/.test(p.material_hash) &&
    p.change_id === `mack_flow_vix_change_${p.material_hash}`;
}

export function subscribeMackFlowChanges(socket: CalculatorSocket, reload: () => void): () => void {
  const seen = new Set<string>();
  const changed = (detail: unknown) => {
    if (!isMackFlowChange(detail) || seen.has(detail.change_id)) return;
    seen.add(detail.change_id);
    while (seen.size > 256) seen.delete(seen.values().next().value as string);
    reload();
  };
  socket.on('mack_flow_changed', changed);
  // The existing Inputs subscription owns Flow's reconnect refresh.
  return () => { socket.off('mack_flow_changed', changed); };
}
